import * as React from "react";
import { RouterRule } from "../../types";
import { getScreen } from "../../utils/getScreen";
import { getWidgetData } from "../../reducers/methods";

export interface RouterProps {
  rules: RouterRule[];
  defaultScreen: string;
  data: ReturnType<typeof getWidgetData>;
  configName: string;
  // tslint:disable-next-line:no-any
  [otherProps: string]: any;
}

export class Router extends React.Component<RouterProps> {
  componentDidMount() {
    const screen =
      getScreen(this.props.rules, this.props.data) || this.props.defaultScreen;
    this.props.setScreenName(screen);
  }

  render() {
    return null;
  }
}
